import { get } from "lodash"

export function parseProductPromotion(promotionCode, typeProduct, productValue, quantity = 0) {
    return {
        channel: 'VPT',
        products: [
            {
                productType: typeProduct,
                productValue: [{
                  id: productValue,
                  count: quantity
                }],
            }
        ],
        promotionCode,
        useDate: ''
    }
}

export function getDiscountValueSKU(coupon, type, price = 0, productId, item = []) {
    if (coupon && coupon.productValue.includes(productId)) {
      if(type === 'VOUCHER') {
        const priceDiscount = calcPrice(price, coupon)
        return getFinalPrice(priceDiscount, coupon) * item.quantity
      } else {
        return getPriceDiscountTicket(item, coupon)
      }
    } else {
      return 0
    }
}

  
export function getPriceDiscountTicket(item, coupon) {
    const decrementAdultPrice = getFinalPrice(calcPrice(get(item, 'ticketPrice.adultSalePrice', 0), coupon), coupon) * get(item, 'quantity', 0)
    const decrementChildPrice = getFinalPrice(calcPrice(get(item, 'ticketPrice.childSalePrice', 0), coupon), coupon) * get(item, 'childQuantity', 0)
    const decrementSeniorPrice = getFinalPrice(calcPrice(get(item, 'ticketPrice.seniorSalePrice', 0), coupon), coupon) * get(item, 'seniorQuantity', 0)
    const decrementIfantrice = getFinalPrice(calcPrice(get(item, 'ticketPrice.infantSalePrice', 0), coupon), coupon) * get(item, 'infantQuantity', 0)
    return decrementAdultPrice + decrementChildPrice + decrementSeniorPrice + decrementIfantrice
}
  
export function calcPrice(price, coupon) {
    return Number((coupon.getDiscountValue(price)).toFixed())
}
  
export function getFinalPrice(priceDiscount, coupon) {
    return coupon.maxDiscountValues > 0 && coupon.maxDiscountValues < priceDiscount ? coupon.maxDiscountValues : priceDiscount
}